var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dl",
    { staticClass: "row" },
    [
      _vm.contact.woonplaats.length == 1
        ? _c("dt", { staticClass: "col-sm-3" }, [
            _vm._v(
              "\n     " +
                _vm._s(_vm.labels.woonplaats.objectName.singular) +
                "\n   "
            )
          ])
        : _c("dt", { staticClass: "col-sm-3" }, [
            _vm._v(_vm._s(_vm.labels.woonplaats.objectName.plural))
          ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _vm._v(
          "\n     " +
            _vm._s(_vm.contact.woonplaats[0].straat) +
            " " +
            _vm._s(_vm.contact.woonplaats[0].nr) +
            "\n     " +
            _vm._s(_vm.contact.woonplaats[0].bus)
        ),
        _c("br"),
        _vm._v(
          "\n     " +
            _vm._s(_vm.contact.woonplaats[0].hfdPostnr) +
            "\n     " +
            _vm._s(_vm.contact.woonplaats[0].deelgemeente)
        ),
        _c("br"),
        _vm._v("\n     " + _vm._s(_vm.contact.woonplaats[0].land.land)),
        _c("br")
      ]),
      _vm._v(" "),
      _vm.contact.verblijfplaats.length == 1
        ? _c("dt", { staticClass: "col-sm-3" }, [
            _vm._v(
              "\n     " +
                _vm._s(_vm.labels.verblijfplaats.objectName.singular) +
                "\n   "
            )
          ])
        : _c("dt", { staticClass: "col-sm-3" }, [
            _vm._v(
              "\n     " +
                _vm._s(_vm.labels.verblijfplaats.objectName.plural) +
                "\n   "
            )
          ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _vm._v(
          "\n     " +
            _vm._s(_vm.contact.verblijfplaats[0].straat) +
            " " +
            _vm._s(_vm.contact.verblijfplaats[0].nr) +
            "\n     " +
            _vm._s(_vm.contact.verblijfplaats[0].bus)
        ),
        _c("br"),
        _vm._v(
          "\n     " +
            _vm._s(_vm.contact.verblijfplaats[0].hfdPostnr) +
            "\n     " +
            _vm._s(_vm.contact.verblijfplaats[0].deelgemeente)
        ),
        _c("br"),
        _vm._v("\n     " + _vm._s(_vm.contact.verblijfplaats[0].land.land)),
        _c("br")
      ]),
      _vm._v(" "),
      _vm.contact.correspondentie.length == 1
        ? _c("dt", { staticClass: "col-sm-3" }, [
            _vm._v(
              "\n     " +
                _vm._s(_vm.labels.correspondentie.objectName.singular) +
                "\n   "
            )
          ])
        : _c("dt", { staticClass: "col-sm-3" }, [
            _vm._v(
              "\n     " +
                _vm._s(_vm.labels.correspondentie.objectName.plural) +
                "\n   "
            )
          ]),
      _vm._v(" "),
      _c("dd", { staticClass: "col-sm-9" }, [
        _vm._v(
          "\n     " +
            _vm._s(_vm.contact.correspondentie[0].straat) +
            "\n     " +
            _vm._s(_vm.contact.correspondentie[0].nr) +
            " " +
            _vm._s(_vm.contact.correspondentie[0].bus)
        ),
        _c("br"),
        _vm._v(
          "\n     " +
            _vm._s(_vm.contact.correspondentie[0].hfdPostnr) +
            "\n     " +
            _vm._s(_vm.contact.correspondentie[0].deelgemeente)
        ),
        _c("br"),
        _vm._v("\n     " + _vm._s(_vm.contact.correspondentie[0].land.land)),
        _c("br")
      ]),
      _vm._v(" "),
      _vm.contact.comnummer.length == 1
        ? _c("dt", { staticClass: "col-sm-3" }, [
            _vm._v(
              "\n     " +
                _vm._s(_vm.labels.comnummer.objectName.singular) +
                "\n   "
            )
          ])
        : _c("dt", { staticClass: "col-sm-3" }, [
            _vm._v(
              "\n     " +
                _vm._s(_vm.labels.comnummer.objectName.plural) +
                "\n   "
            )
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-9" }),
      _vm._v(" "),
      _vm._l(_vm.contact.comnummer, function(number, index) {
        return [
          _c(
            "dt",
            {
              key: "dt-comnummer-" + parseInt(index),
              staticClass: "col-sm-3",
              staticStyle: { "padding-left": "2em" }
            },
            [_vm._v("\n       " + _vm._s(number.type) + "\n     ")]
          ),
          _vm._v(" "),
          _c(
            "dd",
            { key: "dd-comnummer-" + parseInt(index), staticClass: "col-sm-9" },
            [
              _vm._v("\n       " + _vm._s(number.nummer) + "\n       "),
              _c("div", { attrs: { "v:if": "number.opm" } }, [
                _c("i", [_vm._v(_vm._s(number.opm))])
              ])
            ]
          )
        ]
      }),
      _vm._v(" "),
      _vm._l(_vm.contact.email, function(email, index) {
        return [
          _vm.contact.email.length == 1
            ? _c("dt", { key: "lbl-" + index, staticClass: "col-sm-3" }, [
                _vm._v(
                  "\n       " +
                    _vm._s(_vm.labels.email.objectName.singular) +
                    "\n     "
                )
              ])
            : _c("dt", { key: "lbl-" + index, staticClass: "col-sm-3" }, [
                _vm._v(
                  "\n       " +
                    _vm._s(_vm.labels.email.objectName.singular) +
                    " " +
                    _vm._s(index + 1) +
                    "\n     "
                )
              ]),
          _vm._v(" "),
          _c("dd", { key: "mail-" + index, staticClass: "col-sm-9" }, [
            _vm._v(_vm._s(email.emailAdres))
          ])
        ]
      }),
      _vm._v(" "),
      _vm._l(_vm.contact.werkEmail, function(werkEmail, index) {
        return [
          _vm.contact.werkEmail.length == 1
            ? _c(
                "dt",
                { key: "lblWerkEmail-" + index, staticClass: "col-sm-3" },
                [
                  _vm._v(
                    "\n       " +
                      _vm._s(_vm.labels.werkEmail.objectName.singular) +
                      "\n     "
                  )
                ]
              )
            : _c(
                "dt",
                { key: "lblWerkEmail-" + index, staticClass: "col-sm-3" },
                [
                  _vm._v(
                    "\n       " +
                      _vm._s(_vm.labels.werkEmail.objectName.singular) +
                      " " +
                      _vm._s(index + 1) +
                      "\n     "
                  )
                ]
              ),
          _vm._v(" "),
          _c("dd", { key: "werkEmail-" + index, staticClass: "col-sm-9" }, [
            _vm._v("\n       " + _vm._s(werkEmail.emailAdres) + "\n     ")
          ])
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }